import uuid from 'uuid/v1';
import BaseService from '../abstracts/BaseService';

export default class LoaderService extends BaseService {
  get Messages() {
    return {
      [this.CUSTOM_MESSAGES.LOADER_EVENTS.show]: this.appendLoader,
      [this.CUSTOM_MESSAGES.LOADER_EVENTS.hide]: this.removeLoader
    };
  }

  static get SELECTORS() {
    return {
      loader: '.js-loader',
      message: '.js-message'
    };
  }

  constructor() {
    super();

    this.activeLoader = {};
    this.timeoutFunction = {};
  }

  /**
   *
   * @param {String} [message]
   */
  static loaderElement(message) {
    const loaderEl = document.createElement('div');
    const dots = '<span class="dot"></span><span class="dot"></span><span class="dot"></span>';
    loaderEl.classList.add('loader', 'js-loader');
    loaderEl.innerHTML = dots;
    if (message) LoaderService.appendMessage(message, loaderEl);

    return loaderEl;
  }

  /**
   *
   * @param {String} message
   * @param {String} [icon=icon-check]
   * @param {Boolean} [error=false]
   *
   * @returns {Element}
   */
  static messageElement(message, icon = 'icon-check', error = false) {
    const messageEl = document.createElement('div');
    messageEl.classList.add('message', 'js-message');
    if (icon) messageEl.classList.add(error ? 'icon-alert' : icon);
    if (error) messageEl.classList.add('error');
    if (!error) messageEl.classList.add('success');
    messageEl.innerText = message;

    return messageEl;
  }

  /**
   *
   * @param {HTMLElement} [container]
   */
  appendLoader({ container, message }) {
    try {
      const activeLoader = container.querySelector(LoaderService.SELECTORS.loader);
      const dataUuid = container.getAttribute('data-loader');

      if (!dataUuid) {
        const elUuid = uuid();
        container.setAttribute('data-loader', elUuid);
        this.activeLoader[elUuid] = [container];
      } else {
        this.activeLoader[dataUuid].push(container);
      }

      if (!activeLoader) {
        container.style.overflow = 'hidden';
        container.setAttribute('disabled', 'disabled');
        container.insertBefore(LoaderService.loaderElement(message), container.firstChild);
      }
    } catch (e) {
      console.error(e);
    }
  }

  static appendMessage(message, container, icon, error) {
    const messageEl = LoaderService.messageElement(message, icon, error);
    container.appendChild(messageEl);
    messageEl.classList.add('visible');
    return messageEl;
  }

  /**
   *
   * @param {HTMLElement} [container]
   * @param {String} [message]
   * @param {String} [icon]
   * @param {Boolean} [error]
   */
  removeLoader({
    container, message, icon, error
  }) {
    try {
      const dataUuid = container.getAttribute('data-loader');
      const activeLoader = container.querySelector(LoaderService.SELECTORS.loader);

      if (message) {
        const messageEl = LoaderService.appendMessage(message, container, icon, error);
        setTimeout(() => {
          messageEl.classList.remove('visible');
        }, 1500);
        setTimeout(() => {
          messageEl.parentElement.removeChild(messageEl);
        }, 2500);
      }

      if (this.activeLoader[dataUuid] && this.activeLoader[dataUuid].length) {
        this.activeLoader[dataUuid].pop();
        if (this.activeLoader[dataUuid].length === 0) delete this.activeLoader[dataUuid];
      }

      if (activeLoader && !this.activeLoader[dataUuid]) {
        container.removeAttribute('data-loader');
        container.removeAttribute('disabled');
        container.style.overflow = '';
        activeLoader.parentElement.removeChild(activeLoader);
      }
    } catch (e) {
      console.error(e);
    }
  }
}
